import React, { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { postRequest } from "services/api";
import {
  DataGridPremium,
  useGridApiRef,
  GRID_DETAIL_PANEL_TOGGLE_FIELD,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarQuickFilter,
  GridToolbarExport,
} from "@mui/x-data-grid-premium";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Drawer,
  FormLabel,
  Grid,
  IconButton,
  OutlinedInput,
  Snackbar,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import DateRangePicker from "react-bootstrap-daterangepicker";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { Link } from "react-router-dom";
import SendIcon from "@mui/icons-material/Send";
import DownloadIcon from "@mui/icons-material/Download";

const columns = [
  {
    field: "CustomerName",
    headerClassName: "headingbg-color",
    headerName: "Customer Name",
  },
  {
    field: "CustomerOrderNumber",
    headerClassName: "headingbg-color",
    headerName: "Customer Order",
  },
  {
    field: "IGDOrderNumber",
    headerClassName: "headingbg-color",
    headerName: "IGD Order",
  },

  {
    field: "CustomerPOnumber",
    headerClassName: "headingbg-color",
    headerName: "Customer PO Number",
  },
  {
    field: "orderStatus",
    headerClassName: "headingbg-color",
    headerName: "Order status",
  },
  {
    field: "ShipToName",
    headerClassName: "headingbg-color",
    headerName: "Ship To Name",
  },
  {
    field: "ShipToAddress",
    headerClassName: "headingbg-color",
    headerName: "Ship To Address",
  },
  {
    field: "BillToName",
    headerClassName: "headingbg-color",
    headerName: "Bill To Name",
  },
  {
    field: "OrderShipDate",
    headerClassName: "headingbg-color",
    headerName: "Order Start Ship Date",
  },
  {
    field: "OrderCancelDate",
    headerClassName: "headingbg-color",
    headerName: "Order Cancel After Date",
  },
  {
    field: "MustArriveByDate",
    headerClassName: "headingbg-color",
    headerName: "MAB Date",
  },
  // {
  //   field: "ScheduledShipDate",
  //   headerClassName: "headingbg-color",
  //   headerName: "Scheduled Ship Date",
  // },
  {
    field: "QtyOrdered",
    headerClassName: "headingbg-color",
    headerName: "Quantity Ordered",
    type: "number",
    groupable: false,
  },
  {
    field: "PcsOrdered",
    headerClassName: "headingbg-color",
    headerName: "Pieces Ordered",
    type: "number",
    groupable: false,
  },
  {
    field: "TotalCube",
    headerClassName: "headingbg-color",
    headerName: "Total Cube",
    type: "number",
    groupable: false,
  },
  {
    field: "TotalWeight",
    headerClassName: "headingbg-color",
    headerName: "Total Weight",
    type: "number",
    groupable: false,
  },
  {
    field: "GroupingNumber",
    headerClassName: "headingbg-color",
    headerName: "Grouping Number",
  },
  {
    field: "RoutingNotesWithTMS",
    renderCell: (params) => {
      if (params.value) {
        const dataArray = params.value.split("~");

        return (
          <Link href="#" title={dataArray[0].toString()}>
            {dataArray[0].toString()}
          </Link>
        );
      } else {
        return params.value && params.value.toString();
      }
    },
    headerClassName: "headingbg-color",
    headerName: "Routing Notes",
  },
  {
    field: "DateEnteredForRouting",
    headerClassName: "headingbg-color",
    headerName: "Date Entered for Routing",
  },
];

const RouteOrder = () => {
  const apiRef = useGridApiRef();
  const [isLoading, setIsLoading] = useState(false);
  const { user, userSetting } = useSelector((state) => state.user);
  const [orderData, setOrderData] = React.useState([]);
  const [routingDate, setRoutingDate] = useState();
  const [shipToName, setShipToName] = useState("");
  const [billToName, setBillToName] = useState("");
  const [clearFormData, setClearFormData] = useState(false);
  const [routingNotes, setRoutingNotes] = useState("");
  const [groupingNumber, setGroupingNumber] = useState("");
  const [groupingNum, setGroupingNum] = useState("");
  const [poNum, setPoNum] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [routingData, setRoutingData] = useState([]);
  const [apiMsg, setApiMsg] = useState("");
  const [error, setError] = useState("");
  const [open, setOpen] = useState(false);
  const [mustArriveDate, setMustArriveDate] = useState({
    from_mustArriveByDt: "",
    to_mustArriveByDt: "",
  });

  const [scheduleShipDate, setScheduleShipDate] = useState({
    from_startShipDt: "",
    to_startShipDt: "",
  });

  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  const [rowsData, setRowsData] = useState([]);

  const [templateFile, setTemplateFile] = useState('');

  const templateFileRef = useRef(null);

  const labelArriveDate = mustArriveDate.from_mustArriveByDt
    ? mustArriveDate.from_mustArriveByDt.format("MMMM D, YYYY") +
      " - " +
      mustArriveDate.to_mustArriveByDt.format("MMMM D, YYYY")
    : "Must arrive by date";

  const labelScheduleShipDate = scheduleShipDate.from_startShipDt
    ? scheduleShipDate.from_startShipDt.format("MMMM D, YYYY") +
      " - " +
      scheduleShipDate.to_startShipDt.format("MMMM D, YYYY")
    : "Order Start Ship Date";

  useEffect(() => {
    const rows = orderData?.map((c, index) => ({
      id: index,
      WHSEID: c.WHSEID,
      CustomerName: c.CustomerName,
      CustomerOrderNumber: c.CustomerOrderNumber,
      IGDOrderNumber: c.IGDOrderNumber,
      CustomerPOnumber: c.CustomerPOnumber,
      orderStatus: c.orderStatus,
      ShipToName: c.ShipToName,
      ShipToAddress: c.ShipToAddress,
      BillToName: c.BillToName,
      OrderShipDate: c.OrderShipDate,
      OrderCancelDate: c.OrderCancelDate,
      MustArriveByDate: c.MustArriveByDate,
      ScheduledShipDate: c.ScheduledShipDate,
      QtyOrdered: c.QtyOrdered,
      PcsOrdered: c.PcsOrdered,
      TotalCube: c.TotalCube,
      TotalWeight: c.TotalWeight,
      GroupingNumber: c.GroupingNumber,
      RoutingNotesWithTMS: c.RoutingNotesWithTMS,
      DateEnteredForRouting: c.DateEnteredForRouting,
      isSelectable: true,
    }));

    setRowsData(rows);
  }, [orderData]);

  const fetchOrderTableData = async () => {
    setIsLoading(true);
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };
    let payload = {
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      shipToName: shipToName ? shipToName : "all",
      billToName: billToName ? billToName : "all",
      from_mustArriveByDt: mustArriveDate.from_mustArriveByDt
        ? mustArriveDate.from_mustArriveByDt.format("YYYY-MM-DD")
        : "",
      to_mustArriveByDt: mustArriveDate.to_mustArriveByDt
        ? mustArriveDate.to_mustArriveByDt.format("YYYY-MM-DD")
        : "",
      from_startShipDt: scheduleShipDate.from_startShipDt
        ? scheduleShipDate.from_startShipDt.format("YYYY-MM-DD")
        : "",
      to_startShipDt: scheduleShipDate.to_startShipDt
        ? scheduleShipDate.to_startShipDt.format("YYYY-MM-DD")
        : "",
      groupingNumber: groupingNum ? groupingNum : "all",
      customerPOnumber: poNum ? poNum : "all",
    };
    const response = await postRequest(
      "user/getOrders_ToRoute",
      payload,
      headers
    );
    setClearFormData(false);
    setOrderData(response.data.Payload);
    setIsLoading(false);
  };

  const handleUpdateData = async () => {
    let headers = {
      "Content-Type": "application/json;",
      Authorization: `Bearer ${user.token}`,
    };

    let selectedRows = apiRef.current.getSelectedRows();
    let pushedArrayToString = [];
    for (let [key, value] of selectedRows) {
      console.log(key + " is " + value);
      pushedArrayToString.push(value.IGDOrderNumber);
    }
    let payload = {
      custCode: userSetting[0].currCustomer,
      whseCode: userSetting[0].currWarehouse,
      orderKeys: pushedArrayToString.toString(),
      routingGroupNum: groupingNumber,
      routingNotes: routingNotes,
      dateEnteredForRouting: routingDate,
      user: "admin",
    };
    const response = await postRequest(
      "user/save_ordersRoutingGroup",
      payload,
      headers
    );

    if (response.data.Payload) {
      fetchOrderTableData();
      setRowSelectionModel([]);
      setGroupingNumber("");
      setRoutingNotes("");
      setRoutingDate();
      setOpen(true);
      setApiMsg(response.data.Payload[0].message);
      setError(false);
      setDrawerOpen(false);
      // setTimeout(() => {
      //   setOpen(false);
      //   setTimeout(() => {
      //     setApiMsg("");
      //   }, 0);
      // }, 3000);
    } else {
      setApiMsg(response.data.Message);
      setError(true);
      setOpen(true);
      // setTimeout(() => {
      //   setOpen(false);
      // }, 3000);
    }
  };

  useEffect(() => {
    fetchOrderTableData();
  }, [userSetting]);

  const handleCallback = (start, end) => {
    setMustArriveDate({ from_mustArriveByDt: start, to_mustArriveByDt: end });
  };

  const handleScheduleShipDateCallback = (start, end) => {
    setScheduleShipDate({ from_startShipDt: start, to_startShipDt: end });
  };

  const handleSearch = (e) => {
    if (e) {
      e.preventDefault();
    }
    fetchOrderTableData();
  };

  const handleUpdate = () => {
    handleUpdateData();
  };

  const clearForm = () => {
    setScheduleShipDate({ from_startShipDt: "", to_startShipDt: "" });
    setMustArriveDate({ from_mustArriveByDt: "", to_mustArriveByDt: "" });
    setGroupingNum("");
    setShipToName("");
    setBillToName("");
    setPoNum("");
    setClearFormData(true);
  };
  useEffect(() => {
    if (clearFormData) {
      fetchOrderTableData();
    }
  }, [clearFormData]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
    setApiMsg("")
  };

  function CustomToolbar(props) {
    return (
      <GridToolbarContainer {...props}>
        <GridToolbarColumnsButton
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        <GridToolbarFilterButton
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        <GridToolbarDensitySelector
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        {/* <GridToolbarExport /> */}
        <GridToolbarExport
          slotProps={{ button: { sx: { fontSize: "14px" } } }}
        />
        {rowSelectionModel.length > 0 && (
          <Button
            onClick={() => {
              let selectedRows = apiRef.current.getSelectedRows();
              let pushedArrayToString = [];

              for (let [key, value] of selectedRows) {
                console.log(key + " is " + value);
                pushedArrayToString.push(value.GroupingNumber);
              }
              setGroupingNumber(
                pushedArrayToString[0] === null ? "" : pushedArrayToString[0]
              );
              setApiMsg("");
              setError(false);
              setDrawerOpen(true);
            }}
          >
            Mass Order Update
          </Button>
        )}
        <Box sx={{ flexGrow: 1 }} />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  const toggleDrawer = (newOpen) => () => {
    setDrawerOpen(newOpen);
  };

  const handleCellSelectionModelChange = useCallback((newModel) => {
    Object.entries(newModel).forEach(([id, fields]) => {
      if (fields.RoutingNotesWithTMS) {
        const updatedRow = apiRef.current.getRow(id);
        const data = updatedRow.RoutingNotesWithTMS;
        const dataArray = data.split("~");
        setRoutingData(dataArray);
        setOpenPopUp(true);
      }
    });
  }, []);

  const handleFileChange = (event) => {
    setTemplateFile(event.currentTarget.files[0]);
  };

  const handleTemplateUpload = async (e) => {
    e.preventDefault();
    if (!templateFile) {
      alert("Please Select a File");
      return;
    }

    const formData = new FormData();

    formData.append("file", templateFile);
    formData.append("custCode", userSetting[0].currCustomer);
    formData.append("whseCode", userSetting[0].currWarehouse);

    let headers = {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${user.token}`,
    };

    const response = await postRequest(
      "user/getOrders_byExcelUploadSearch",
      formData,
      headers
    );

    if (response.data.Status === 1) {
      setOrderData(response.data.Payload);
      setRowSelectionModel(response.data.Payload.map((item, index) => index));
    } else {
      setOpen(true);
      setApiMsg(response.data.Message);
      setError(true);

      // setTimeout(() => {
      //   setOpen(false);
      //   setTimeout(() => {
      //     setApiMsg("");
      //   }, 0);
      // }, 3000);
    }

    // setTemplateFile('');
    // if (templateFileRef.current) {
    //   templateFileRef.current.value = "";
    // }

    setTimeout(() => {
      setTemplateFile("");
      if (templateFileRef.current) {
        templateFileRef.current.value = ""; // ✅ Clear actual input value
      }
    }, 1000)
  };

  const handleTemplateDownload = () => {
    const link = document.createElement("a");
    link.href = "template_bulkOrderUpdateSearch.xlsx";
    link.download = "template_bulkOrderUpdateSearch.xlsx"; // optional
    link.click();
  };

  return (
    <>
      <Box
        sx={{ display: "flex", position: "absolute", right: "0", top: "-2px" }}
      >
        <Stack spacing={2} direction="row">
          <TextField
            inputRef={templateFileRef}
            variant="outlined"
            placeholder="BOL File"
            onChange={handleFileChange}
            type="file"
            inputProps={{
              multiple: false,
              accept: ".xlsx, .xls",
            }}
            sx={{
              "& .MuiInputBase-root": {
                height: "37.5px",
                paddingTop: '15px'
              },
              "& input": {
                height: "37.5px",
                padding: "8px",
              },
            }}
          />

          <Tooltip title="Choose File">
            <IconButton
              color="primary"
              onClick={handleTemplateUpload}
              sx={{ width: 40 }}
            >
              <SendIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Download Template">
            <IconButton onClick={handleTemplateDownload} sx={{ width: 40 }}>
              <DownloadIcon />
            </IconButton>
          </Tooltip>
        </Stack>
      </Box>
      <div>
        <form onSubmit={handleSearch}>
          <Grid container spacing={1} sx={{ marginTop: "15px" }}>
            <Grid item xs={12} md={1.4}>
              <div>
                <OutlinedInput
                  name="grouping-num"
                  placeholder="Grouping Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={groupingNum}
                  onChange={(e) => setGroupingNum(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.4}>
              <div>
                <OutlinedInput
                  name="cust-po-num"
                  placeholder="Po Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={poNum}
                  onChange={(e) => setPoNum(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.3}>
              <div>
                <OutlinedInput
                  name="ship-to-name"
                  placeholder="Ship To Name"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  onChange={(e) => setShipToName(e.target.value)}
                  value={shipToName}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={1.3}>
              <div>
                <OutlinedInput
                  name="bill-to-name"
                  placeholder="Bill To Name"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                      fontSize: "0.8rem",
                    },
                  }}
                  value={billToName}
                  onChange={(e) => setBillToName(e.target.value)}
                />
              </div>
            </Grid>
            <Grid item xs={12} md={2.2}>
              <div>
                <DateRangePicker
                  initialSettings={{
                    startDate: mustArriveDate.from_mustArriveByDt
                      ? mustArriveDate.from_mustArriveByDt.toDate()
                      : moment().toDate(),
                    endDate: mustArriveDate.to_mustArriveByDt
                      ? mustArriveDate.to_mustArriveByDt.toDate()
                      : moment().toDate(),
                  }}
                  onCallback={handleCallback}
                >
                  <div
                    id="reportrange"
                    className="box-with-icon filterCalendar"
                  >
                    <span
                      style={{
                        fontSize: "0.8rem",
                        paddingTop: "3px",
                        color: mustArriveDate.from_mustArriveByDt
                          ? "rgba(0, 0, 0, 0.87)"
                          : "#636c72",
                      }}
                    >
                      {labelArriveDate}
                    </span>
                    <CalendarMonthOutlinedIcon />
                  </div>
                </DateRangePicker>
              </div>
            </Grid>
            <Grid item xs={12} md={2.2}>
              <div>
                <DateRangePicker
                  initialSettings={{
                    startDate: scheduleShipDate.from_startShipDt
                      ? scheduleShipDate.from_startShipDt.toDate()
                      : moment().toDate(),
                    endDate: scheduleShipDate.to_startShipDt
                      ? scheduleShipDate.to_startShipDt.toDate()
                      : moment().toDate(),
                  }}
                  onCallback={handleScheduleShipDateCallback}
                  slotProps={{ textField: { placeholder: "tt.mm.jjjj" } }}
                >
                  <div
                    id="reportrange"
                    className="box-with-icon filterCalendar"
                  >
                    <span
                      style={{
                        fontSize: "0.8rem",
                        paddingTop: "3px",
                        color: scheduleShipDate.from_startShipDt
                          ? "rgba(0, 0, 0, 0.87)"
                          : "#636c72",
                      }}
                    >
                      {labelScheduleShipDate}
                    </span>
                    <CalendarMonthOutlinedIcon />
                  </div>
                </DateRangePicker>
              </div>
            </Grid>

            <Grid item xs={12} md={2}>
              <Stack direction="row" spacing={0}>
                <IconButton
                  aria-label="submit"
                  color="primary"
                  type="submit"
                  onClick={handleSearch}
                >
                  <SearchIcon />
                </IconButton>
                <IconButton
                  aria-label="clear"
                  color="secondry"
                  onClick={clearForm}
                >
                  <ClearIcon />
                </IconButton>
              </Stack>
            </Grid>

            {/* <Grid item xs={12} md={12}>
            <Stack
              direction="row"
              spacing={2}
              sx={{ justifyContent: "flex-end", alignItems: "flex-start" }}
            >
              <Button
                variant="contained"
                onClick={() => setDrawerOpen(true)}
                size="small"
              >
                Mass Update Order
              </Button>
            </Stack>
          </Grid> */}
          </Grid>
        </form>
      </div>
      <div
        style={{
          height: 700,
          width: "100%",
          marginTop: "20px",
          background: "#fff",
        }}
      >
        <DataGridPremium
          loading={isLoading}
          apiRef={apiRef}
          columns={columns}
          rows={rowsData}
          slots={{ toolbar: CustomToolbar }}
          sx={{
            "& .MuiDataGrid-detailPanel": {
              overflow: "visible",
            },
            "& .MuiButton-text": { fontSize: "14px" },
            ".MuiDataGrid-aggregationColumnHeaderLabel": {
              display: "none",
            },
            "& .MuiDataGrid-columnHeaderCheckbox .MuiDataGrid-columnHeaderTitleContainer":
              {
                display: "none",
                backgroundColor: "rgb(103 130 219)",
              },
          }}
          pinnedColumns={{ left: [GRID_DETAIL_PANEL_TOGGLE_FIELD] }}
          pagination
          pageSizeOptions={[30, 50, 100, 200]}
          initialState={{
            pagination: { paginationModel: { pageSize: 50 } },
            aggregation: {
              model: {
                QtyOrdered: "sum",
                PcsOrdered: "sum",
                TotalCube: "sum",
                TotalWeight: "sum",
              },
            },
          }}
          checkboxSelection
          disableRowSelectionOnClick
          onRowSelectionModelChange={(newRowSelectionModel, detail) => {
            // let newModel = [];
            // if (newRowSelectionModel.length > rowSelectionModel.length) {
            //   const GroupingNumber = detail.api.getRow(
            //     newRowSelectionModel[newRowSelectionModel.length - 1]
            //   ).GroupingNumber;
            //   const filterLoadData = rowsData.filter(
            //     (data) =>
            //       data.GroupingNumber === GroupingNumber &&
            //       data.GroupingNumber !== null
            //   );
            //   if (filterLoadData.length === 0) {
            //     let checkIfAnyGrouping = false;
            //     for (let i = 0; i < rowSelectionModel.length; i++) {
            //       const GroupingNumber = detail.api.getRow(
            //         rowSelectionModel[i]
            //       ).GroupingNumber;

            //       if (GroupingNumber) {
            //         checkIfAnyGrouping = true;
            //         break;
            //       }
            //     }
            //     if (checkIfAnyGrouping) {
            //       newModel = [
            //         newRowSelectionModel[newRowSelectionModel.length - 1],
            //       ];
            //     } else {
            //       newModel = newRowSelectionModel;
            //     }
            //   } else {
            //     newModel = filterLoadData.map((data) => data.id);
            //   }
            // } else {
            //   let checkIfAnyGrouping = false;
            //   for (let i = 0; i < rowSelectionModel.length; i++) {
            //     const GroupingNumber = detail.api.getRow(
            //       rowSelectionModel[i]
            //     ).GroupingNumber;

            //     if (GroupingNumber) {
            //       checkIfAnyGrouping = true;
            //       break;
            //     }
            //   }
            //   if (checkIfAnyGrouping) {
            //     newModel = [];
            //   } else {
            //     newModel = newRowSelectionModel;
            //   }
            // }
            setRowSelectionModel(newRowSelectionModel);
          }}
          rowSelectionModel={rowSelectionModel}
          onCellSelectionModelChange={handleCellSelectionModelChange}
          cellSelection={true}
          isRowSelectable={(params) => params.row.isSelectable}
        />
      </div>

      <Snackbar open={open} onClose={handleClose}>
        <Alert
          severity={!error && apiMsg ? "success" : "error"}
          variant="filled"
          sx={{ width: "100%" }}
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={handleClose}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          }
        >
          {apiMsg}
        </Alert>
      </Snackbar>

      <Drawer open={drawerOpen} onClose={toggleDrawer(false)} anchor="right">
        <div className="filter-drawer">
          <div className="filter-header-wrap">
            <span>Update Order Details</span>
            <IconButton aria-label="close" onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ fontSize: "0.9rem", marginTop: "2rem" }}>
              <FormLabel htmlFor="grouping-number">
                Grouping Number <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <div>
                <OutlinedInput
                  name="grouping-number"
                  placeholder="Enter Grouping Number"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={groupingNumber}
                  onChange={(e) => setGroupingNumber(e.target.value)}
                  //disabled={groupingNumber}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="routing-notes">Routing Notes</FormLabel>
              <div>
                <OutlinedInput
                  name="routing-notes"
                  placeholder="Enter Routing Notes"
                  fullWidth
                  inputProps={{
                    style: {
                      height: "0.3rem",
                    },
                  }}
                  value={routingNotes}
                  onChange={(e) => setRoutingNotes(e.target.value)}
                  multiline={true}
                  rows={3}
                />
              </div>
            </Grid>

            <Grid item xs={12} sx={{ fontSize: "0.9rem" }}>
              <FormLabel htmlFor="date-for-routing">
                Date Entered for Routing <span style={{ color: "red" }}>*</span>
              </FormLabel>
              <div>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label=""
                    format="YYYY-MM-DD"
                    value={routingDate}
                    className="ml-8"
                    onChange={(newDailyValue) => setRoutingDate(newDailyValue)}
                    slotProps={{
                      textField: {
                        size: "small",
                        height: "0.3rem",
                        placeholder: "Routing Date",
                        fullWidth: true,
                      },
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        padding: "1px 10px 1px 0px",
                        // border: "1px solid #d1d4e2",
                      },
                      height: "0.3rem",
                    }}
                    slots={{ openPickerIcon: CalendarMonthOutlinedIcon }}
                  />
                </LocalizationProvider>
              </div>
            </Grid>

            <Grid item xs={12} md={12} sx={{ marginTop: "25px" }}>
              <Button
                variant="contained"
                onClick={handleUpdate}
                size="small"
                disabled={!routingDate || !groupingNumber}
              >
                Update
              </Button>
            </Grid>
          </Grid>
        </div>
      </Drawer>

      {openPopUp && (
        <Box sx={{ width: "100%", height: "200px" }}>
          <Dialog
            open={openPopUp}
            onClose={() => setOpenPopUp(false)}
            aria-labelledby="form-dialog-title"
            style={{
              height: "100%",
              width: "100%",
              alignItems: "center",
            }}
            fullWidth={true}
            maxWidth={"sm"}
          >
            <DialogTitle
              className="colordivSumHead font-bold"
              id="form-dialog-title"
            >
              Routing Notes:
            </DialogTitle>
            <DialogContent>
              {
                <ul style={{ margin: "0", padding: "0", listStyle: "none" }}>
                  {routingData.map((data, index) => (
                    <li style={{ paddingBottom: "5px" }} key={index}>
                      {data}
                    </li>
                  ))}
                </ul>
              }
            </DialogContent>
          </Dialog>
        </Box>
      )}
    </>
  );
};

export default RouteOrder;
